import React from "react";
import ContactContent from "app/core/components/contact";

const Contact = () => <ContactContent />;

export default Contact;
